<template id="tab-item">
	<div class="ccs-logo-tab-item"
		 role="tab"
		 :class="{ 'ccs-logo-tab-item_active': isActive }"
		 :tabindex="isActive ? -1 : 0"
		 :aria-selected="isActive.toString()"
		 @click="$emit('click', tab)">
		<span>{{ tab.title }}</span>
	</div>
</template>

<script>
	export default {
		template: "#tab-item",
		props: {
			tab: Object,
			isActive: Boolean
		}
	}
</script>

<style>
	.ccs-logo-tab-item {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		flex-basis: 10em;
		margin: 0 .3em;
		padding: .5em .6em;
		font-weight: bold;
		line-height: 1.1em;
		color: white;
		background: #a6a6a6;
		border: 1px solid #8f8f8f;
		border-bottom: none;
		cursor: pointer;
		user-select: none;
		letter-spacing: 0.5px;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-rendering: optimizeLegibility;
	}

		.ccs-logo-tab-item_active {
			background: #484848;
			cursor: default;
			outline: none;
		}

	.ccs-small .ccs-logo-tab-item {
		min-width: 0;
		margin: 0 .2em;
	}

		.ccs-small .ccs-logo-tab-item span {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

	.ccs-small [data-tab-count="3"] .ccs-logo-navbar-icon {
		display: none;
	}
</style>
